module.exports = __webpack_public_path__ + "static/media/pointer-down.f97cf5a2.svg";